import router from '../services/router_service';
import embedController from '../controllers/embed_controller';

router.on('route:embed', embedController);
